import { render, staticRenderFns } from "./RowsByPage.vue?vue&type=template&id=63ca2e94&scoped=true&"
import script from "./RowsByPage.vue?vue&type=script&lang=js&"
export * from "./RowsByPage.vue?vue&type=script&lang=js&"
import style0 from "./RowsByPage.vue?vue&type=style&index=0&id=63ca2e94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ca2e94",
  null
  
)

export default component.exports